import React, { forwardRef } from 'react';
import { StyleSheet, Text, TextProps } from 'react-native';
import theme from 'shared/styles/theme';

const TitleSmText = forwardRef<Text, TextProps>(
  ({ children, style, ...props }, ref) => {
    return (
      <Text
        ref={ref}
        testID="title-sm"
        style={[styles.titleSmText, style]}
        {...props}
      >
        {children}
      </Text>
    );
  },
);

const styles = StyleSheet.create({
  titleSmText: {
    ...theme.typography.title.sm,
    color: theme.color.text.primary,
  },
});

export default TitleSmText;
